const translationCZ = {
  'About Us': 'O nás',
  'MyCookAround is a new social platform and a market place, which connects Cooks and Guests according to sections, searching and location. The Cooks sell their farm products, warm homemade meals, homemade products, wine, fruits, vegetables, surpluses from their gardens but also experiences such as wine growing or cooking classes. MyCookAround connects people and brings economical benefits for the Cooks and the Guests.':
    'MyCookAround je nová sociální síť a marketplace, která podle sekcí nebo vyhledávání a lokalizace propojuje Hosty s jejich kuchaři, kteří prodávají své farmářské výrobky, hotová domácí jídla, produkty, víno, ovoce, zeleninu, přebytky ze zahrádek a také zážitky, jako je například pěstování vinné révy nebo kurzy vaření. MyCookaround spojuje lidi a přináší ekonomické benefity pro Kuchaře i jeho Hosta.',
  'How do I use MyCookAround?': 'Jak se používá MyCookAround?',
  'What are MyCookAround policies?': ' Jaké jsou zásady MyCookAround?',
  'Who can be a Cook?': 'Kdo může být Kuchař?',
  'What do I need to create a Cook’s profile?':
    'Co potřebuji k vytvoření profilu Kuchaře?',
  'What kind of photo should I upload in my profile?':
    'Jakou fotku bych měl nahrát jako profilovou?',
  'When will my Offers go online?':
    'Kdy budou moje Nabídky k dispozici online?',
  'What do I get for the membership I pay to MyCookAround?':
    'Co dostanu za členství, které si na MyCookAround platím?',
  'How many portions/events/items/kilograms can I sell?':
    'Kolik kusů/položek/kilogramů/událostí/zážitků můžu prodávat?',
  'Do I have to sell only main courses as a home Cook?':
    'Pokud jsem domácí Kuchař, musím prodávat jen hlavní jídla?',
  'As a home Cook should I sell only one meal or serve the whole menu?':
    'Jako domácí Kuchař, mám prodávat jen jedno jídlo nebo servírovat celá menu?',
  'As a home Cook What if I am not interested in social dining but I only want to sell meals?':
    'Co když pokud jako domácí kuchař nechci trávit čas se svými Hosty, ale jen prodávat svá jídla?',
  'What if I want to sell my Offers as a home Cook at my place but I only have limited time to spend with my Guests?':
    'Co když chci prodávat své Nabídky jako zážitek u sebe doma, ale mám na své Hosty pouze omezený čas?',
  'How do I set the price?': ' Jak mám nastavit ceny?',
  'How much money can I make on MyCookAround as a Cook?':
    'Kolik si můžu prostřednictvím   MyCookAround vydělat?',
  'As a Cook, how do I deal with Orders I get?':
    'Jako Kuchař, jak získávám objednávky',
  'Is there any way how I can increase my profit as a home Cook?':
    'Jako domácí kuchař, je nějaká možnost, jak si zvýším zisky?',
  'If I am paid via Platform MyCookAround and want to avoid unnecessary bank transfer fees, how do I do it?':
    'Jako Host, jak zkontaktuji Kuchaře, pokud mám k jeho nabídce dotazy?',

  //1
  '<ol><li class="li1"><span class="s1">MyCookAround has the easiest possible manipulation. Even elderly people can manage. The User signs to be either a Cook or a Guest. Everyone can be both and switch in their account between Cook &lsquo;s and Guest &lsquo;s profile. Users can log in with an email address, Facebook account or Google account.</span></li><li class="li1"><span class="s1">You must fill all profile details, including a short introduction e.g. &ldquo;Farmer growing the best oranges&rdquo;, &ldquo;Stay at home mother who cooks for her family every day and takes pride in quality of ingredients and likes to meet new people&rdquo; or &ldquo; Single man who loves to cook but hates to eat alone&rdquo;, &bdquo;Farm growing the best organic chickens&ldquo;, and upload a profile picture.</span></li><li class="li1"><span class="s1">Then as a Cook you fill your payment details including payment threshold, in case you choose to be paid out via Platform MyCookAround. It is a tool that saves money on bank transfers where you set minimum amount to receive your pay outs. To receive money you also will be asked for a scan of your ID. Then you create your Offer (plus icon on Cook &lsquo;s profile) &ndash; it can be one portion of any meal you are cooking, several course menu, event, anything you prepare (homemade jam) or grow (one kilogram of oranges) at home or a cooking class where you offer the whole experience to your Guests. You have to upload a picture of your Offer, fill the description, set the price, how many portions/items/seats you have available, date and time of serving/taking place, estimated time of consumption, take away/eat with/both option and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with your Guests about an additional questions regarding your Offer (when exactly they come etc.).</span></li><li class="li1"><span class="s1">As a Guest you set filters &ndash; distance from the place where you are located at the moment, price range, time, food restrictions, quantity and in case of meal constumptions if you want to eat with or take away. Also you can use key word search. Then MyCookAround gives you matches with the Offers and you can start browsing. The Offers you like you can easily directly Buy via MyCookAround, or cash at Cook&rsquo;s place or agree with the Cook on any suitable kind of an online payment.</span></li><li class="li1"><span class="s1">After Meal sharing/purchase/experience is due, you can rate under each profile of both Cooks and Guests, which builds trust in the community.</span></li><li class="li1"><span class="s1">When you see that a User on the other side is violating our Terms and Conditions, you can report them.</span></li></ol>':
  `<ol>
  <li class="li1"><span class="s1">MyCookAround m&aacute; to nejjednodu&scaron;&scaron;&iacute; možn&eacute; ovl&aacute;d&aacute;n&iacute;, kter&eacute; bez obt&iacute;ž&iacute; zvl&aacute;dnou i star&scaron;&iacute; lid&eacute;. Uživatel vytvoř&iacute; svůj profil jako Kuchař, Host nebo oboj&iacute; a mezi sv&yacute;m profilem Hosta a Kucahře může jednodu&scaron;e přep&iacute;nat. Registrace profilu je možn&aacute; pomoc&iacute; emailov&eacute; adresy, Facebookov&eacute;ho &uacute;čtu nebo Google &uacute;čtu.</span></li>
  <li class="li1"><span class="s1">Mus&iacute;te vyplnit v&scaron;echny detaily profilu včetně kr&aacute;tk&eacute;ho představen&iacute;, např&iacute;klad: &bdquo;Farm&aacute;ř, kter&yacute; pěstuje ta nejlep&scaron;&iacute; jablka &scaron;iroko daleko&ldquo;, &bdquo;Maminka v&nbsp;dom&aacute;cnosti, kter&aacute; pro v&aacute;s uvař&iacute; z&nbsp;těch nejkvalitněj&scaron;&iacute;ch poctiv&yacute;ch surovin&ldquo;, &bdquo;Star&yacute; ml&aacute;denec, co r&aacute;d vař&iacute; a nerad j&iacute; s&aacute;m, proto se o sv&aacute; dom&aacute;c&iacute; j&iacute;dla r&aacute;d poděli s&nbsp;hosty&ldquo;, &bdquo;Farma, kter&aacute; pro v&aacute;s m&aacute; kuř&aacute;tka pěstovan&aacute; ve v&yacute;běhu&ldquo;. Pak už jen nahrajete profilovou fotku.</span></li>
  <li class="li1"><span class="s1">Jako Kuchař vypln&iacute;te svoje platebn&iacute; &uacute;daje včetně platebn&iacute;ho limitu, pakliže si přejete, aby V&aacute;m platby chodily přes platformu MyCookAround. Nastav&iacute;te si limitn&iacute; č&aacute;stku pro sv&eacute; v&yacute;platy a t&iacute;m u&scaron;etř&iacute;te pen&iacute;ze za bankovn&iacute; převody a poplatky. Jako Kuchař, budete pož&aacute;d&aacute;n o sken sv&eacute;ho identifikačn&iacute;ho dokladu.&nbsp;<br />Hned potom můžete vytv&aacute;řet sv&eacute; nab&iacute;dky (tlač&iacute;tko &bdquo;plus&ldquo; na Va&scaron;em profilu). Nab&iacute;zet můžete cokoliv: porci nebo několik j&iacute;dla, kter&aacute; vař&iacute;te, několikachodov&aacute; menu, ud&aacute;lost jako společensk&aacute; večeře, z&aacute;žitky jako sběr vinn&eacute; r&eacute;vy nebo kurzy vařen&iacute;, cokoliv, co doma vypěstujete nebo vytvoř&iacute;te, např&iacute;klad marmel&aacute;dy, zavařeniny, su&scaron;enky, tinktury atd. Fantazii se meze nekladou. U každ&eacute; Nab&iacute;dky mus&iacute;te nahr&aacute;t fotku, vyplnit popisek, nastavit cenu, v&nbsp;př&iacute;padě vařen&iacute;ch j&iacute;del serv&iacute;rovan&yacute;ch v&nbsp;určit&yacute; den uv&eacute;st, kolik porc&iacute; je k&nbsp;dispozici a pokud chcete Hosta pohostit u sebe doma, tak uv&eacute;st i počet m&iacute;st k&nbsp;sezen&iacute;, d&aacute;le mus&iacute;te vyplnit, kdy je možn&eacute; Nab&iacute;dku zakoupit a v&nbsp;př&iacute;padě konzumace j&iacute;dla v&nbsp;v&aacute;s doma, vyplňte tak&eacute; jak&aacute; je oček&aacute;van&aacute; doba konzumace. V&nbsp;tu chv&iacute;li je nab&iacute;dka online. O Objedn&aacute;vce dostanete upozorněn&iacute; do v&aacute;mi uveden&eacute;ho mailu. Se sv&yacute;m Hostem můžete probrat dal&scaron;&iacute; věci t&yacute;kaj&iacute;c&iacute; se Objedn&aacute;vky, jako např&iacute;klad v kolik přesně doraz&iacute;, zda sm&iacute; vz&iacute;t sv&eacute;ho dom&aacute;c&iacute;ho mazl&iacute;čka s sebou atd. v chatu aplikace nebo si mužete zavolat.</span></li>
  <li class="li1"><span class="s1">Jako Host nastavte spr&aacute;vně sv&eacute; filtry: vzd&aacute;lenost, kam jste ochotni si při Nab&iacute;dku přijet od m&iacute;sta, kde se nach&aacute;z&iacute;te, cenov&eacute; rozpět&iacute;, čas, potravinov&eacute; omezen&iacute;, množstv&iacute; a zda v&nbsp;př&iacute;padě tepl&yacute;ch j&iacute;del chcete konzumovat na m&iacute;stě nebo si ho odn&eacute;st s&nbsp;sebou. Stejně tak můžete využ&iacute;t vyhled&aacute;vače podle kl&iacute;čov&yacute;ch slov. MyCookAround v&aacute;m nab&iacute;dne shody s&nbsp;Va&scaron;im vyhled&aacute;v&aacute;n&iacute;m a ty uvid&iacute;te jako Nab&iacute;dky, kter&eacute; můžete snadno proch&aacute;zet. Nab&iacute;dky, kter&eacute; chcete zakoupit můžete zaplatit buď přes platformu MyCookAround, nebo na m&iacute;stě u Kuchaře nebo se s&nbsp;n&iacute;m dohodnout na nějak&eacute; formě online platby.</span></li>
  <li class="li1"><span class="s1">Po skončen&iacute; konzumace/z&aacute;žitku/n&aacute;kupu/ můžete jeden druh&eacute;ho hodnotit, což zvy&scaron;uje důvěru v&nbsp;r&aacute;mci MyCookAround komunity.</span></li>
  <li class="li1"><span class="s1">Pokud vid&iacute;te, že jak&yacute;koliv Uživatel poru&scaron;uje na&scaron;e Obchodn&iacute; Podm&iacute;nky, pros&iacute;m, nahla&scaron;te ho.</span></li>
  </ol>`,

  //2.1
  '<p>MyCookAround has a strict nondiscrimination policy. MyCookAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms. The MyCookAround community is committed to building a world where people from every background feel welcome and respected, no matter how far they have traveled from home. This commitment rests on two foundational principles that apply both to MyCookArounds Cooks and Guests inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on MyCookAround no matter who they are, where they come from, how they worship, or whom they love. MyCookAround Cooks welcome Guests of all backgrounds with authentic hospitality and open minds. Joining MyCookAround, as a Cook or Guest, means becoming part of a community of inclusion. Bias, prejudice, racism, and hatred have no place on our platform or in our community. While Cooks are required to follow all applicable laws that prohibit discrimination based on such factors as race, religion, national origin, and others listed below, we commit to do more than comply with the minimum requirements established by law.</p>':
    '<p>MyCookAround m&aacute; př&iacute;snou antidiskriminačn&iacute; politiku. MyCookAround je ve sv&eacute;m j&aacute;dru otevřen&aacute; komunita, jej&iacute;mž c&iacute;lem je sbližov&aacute;n&iacute; lid&iacute; z&nbsp;cel&eacute;ho světa t&iacute;m. V&nbsp;komunitě MyCookAround jsou lid&eacute; prakticky ze v&scaron;ech zem&iacute; a kultur.<br />Platforma MyCookAround se zav&aacute;zala budovat svět, ve kter&eacute;m se lid&eacute; ze v&scaron;ech prostřed&iacute; c&iacute;t&iacute; v&iacute;t&aacute;ni a respektov&aacute;ni, bez ohledu na to, jak daleko odcestovali z domova. Tento z&aacute;vazek spoč&iacute;v&aacute; na dvou z&aacute;kladn&iacute;ch principech, kter&eacute; plat&iacute; jak pro Kuchaře, tak pro Hosty MyCookAround: toleranci a respekt. N&aacute;&scaron; společn&yacute; z&aacute;vazek k těmto principům umožňuje každ&eacute;mu uživateli c&iacute;tit se na MyCookAround v&iacute;t&aacute;ni bez ohledu na to, kdo jsou, odkud poch&aacute;zej&iacute;, jak uct&iacute;vaj&iacute; nebo koho miluj&iacute;.<br />MyCookAround Kuchaři v&iacute;taj&iacute; Hosty v&scaron;ech prostřed&iacute; s autentickou pohostinnost&iacute; a otevřenou mysl&iacute;. Připojit se k MyCookAround jako Kuchař nebo Host znamen&aacute; st&aacute;t se souč&aacute;st&iacute; komunity. Předsudky, předsudky, rasismus a nen&aacute;vist u n&aacute;s nemaj&iacute; m&iacute;sto.</p>',
  //3
  '<p>All farmers, farms, all homemade food producers or anyone who cooks their meals at home can become a Cook of MyCookAround. Home Cooks can sell one portion of any meal as well a whole event of 5 course menu. Time does not matter. They can sell breakfasts, lunches, dinners or snacks. Also anyone who prepares any kind of food like homemade jams or cookies can sell them via MyCookAround. If you are a farmer grow your own products, MyCookAround is a perfect marketplace for you. If your cooking is really good and you feel confident enough to organize the whole cooking session, you can offer a cooking class. The only limit is the age. You must be over 18 years old.</p>':
    '<p>V&scaron;ichni farm&aacute;ři, farmy, v&scaron;ichni v&yacute;robci dom&aacute;c&iacute;ch produktů nebo j&iacute;del a každ&yacute;, kdo doma vař&iacute; se může st&aacute;t Kuchařem Platformy MyCookAround. Dom&aacute;c&iacute; Kuchaři můžou jednodu&scaron;e prodat jednu porci toho, co vař&iacute; pro sebe nebo svoji rodinu, stejně tak mohou napl&aacute;novat celovečern&iacute; ud&aacute;lost o několika chodech. Co se t&yacute;če času, je na V&aacute;s, kdy chcete sv&eacute; dobroty prod&aacute;vat &ndash; sn&iacute;daně, obědy, večeře, nebo po cel&yacute; den. Stejně tak kdokoliv, kdo um&iacute; dom&aacute;c&iacute; su&scaron;enky, dorty, svačinky, marmel&aacute;dy se může jako Kuchař zaregistrovat a v&yacute;robou sv&yacute;ch pochoutek si přivydělat. Jedin&aacute; podm&iacute;nka je věkov&yacute; limit 18 let.</p>',
  //4
  '<p> Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes. </p>':
    'Pouze chytrý telefon nebo tablet nebo laptop nebo počítač. Vytvoření profilu na Pltafromě MyCookAround zabere zhruba 10 minut.',
  //5
  '<p> It has to be a genuine photo of yourself. As a farm, be it a pic of some of your farmers or he farm. As a private Cook, the best would be a picture in your kitchen when you are cooking or farm where you are working and mainly smiling. </p>':
    '<p> Musí to být opravdová fotka Vaší osoby. Pokud jako Kuchař reprezentujete společnost (farmu), nahrajte buď fotku některého Vašeho farmáře nebo Vaší farmy. Pokud jste domácí Kuchař, nejlépe je fotka Vás samotných usmívajících se ve Vaší kuchyni. </p>',
  //6
  '<p> Immediately. You don‘t have to wait for any approval. </p>':
    '<p> Okamžitě. Nemusíte čekat na žádná schvalování.  </p>',
  //7
  '<p>A powerful, online presence. MyCookAround actively markets your Offers. A dedicated team verifies Guests reviews, making sure they are legitimate. This gives you credibility and helps future Guests make the decision to stay with you. 24/7 support is here for you and your Guests</p>':
    '<p>MyCookAround aktivně zveřejňuje vaše Nabídky. Naplno fungující tým ověřuje rezence Vašich Hostů a jejich legitimitu, což Vám dává důvěryhodnost a pomáhá Hostům při rozhodování se, zda příště nakoupí zase u Vás. Podpora, i ta technická, je zde pro Vás i Vaše hosty 24 hodin 7 dní v&nbsp;týdnů. </p>',
  //8
  '<p> It totally depends on you. If you want to increase your sales as a home Cook, the best way is to have planned what you will cook on a specific day and to upload your Offer a few days in advance. If Guests buy fast, you can upload again and set higher amount of portions/seats at table/items available. It is important to find a good balance to have enough time to get ingredients and sell as much as possible in order not to have any waste. And of course the more Offers you upload, the more sales you will make. </p>':
    '<p>To záleží čistě na Vás. Pokud jste domácí Kuchař a chcete zvýšit Vaše prodeje, nejlepší je, když naplánujete svá menu několik dní předem a tyto Nabídky nahrajete. Pokud vidíte, že je o ně zájem a Hosté je rezervují, můžete zvyšovat množství porcí/míst u Vašeho stolu. Důležité pro Vás je, si najít rovnováhu mezi dostatkem času nakoupit potřebné množství ingrediencí a především tak, abyste nemuseli žádné jídlo vyhazovat a ingrediencemi plýtvat. </p>',
  //9
  '<p> Not at all. If you are good at baking, you can sell your homemade cookies. If you have time only in the morning, you can sell only breakfasts. If you make homemade jams or grow apples, you can sell them. If you want to spend time with your Guests and make more money, you can sell the whole event or a cooking experience. The only condition is homemade food or homemade product. </p>':
    '<p> Vůbec ne. Pokud pečete, můžete prodávat své domácí pekařské výrobky. Pokud máte čas jen ráno, můžete prodávat jen snídaně. Pokud děláte své domácí marmelády, můžete je prodávat. Pokud jste společenský člověk, který chce poznávat nové lidi a trávit se svými Hosty čas a vydělat si tak více peněz, prodávejte celé události nebo jakékoliv kulinářské zážitky. Jediná podmínka je, aby jídlo nebo produkt byly domácí. </p>',
  //10
  '<p> You have to find your balance. You can sell 5 course menu or just one meal or both at the same day. Actually the more Offers you create, the higher your sales will be. You can cook several courses and upload them together and also separately as different Offers. </p>':
    '<p> To je na Vašem zvážení. Můžete prodávat pětichodové menu nebo jednu porci jednoho jídla denně nebo obojí. V&nbsp;podstatě čím více nabídek vytvoříte, tím vyšší budou Vaše prodeje. Můžete uvařit několik chodů a nahrát je jako jednu Nabídku nebo také odděleně jako odlišné nabídky.  </p>',
  //11
  '<p> Then you simply set a function “take away” in your Offers. In this case, please always have food containers. The recommendation of MyCookAround is to use paper boxes, which are recyclable. Also there are Guests who bring their own containers, which you can agree on in a chat. </p>':
    '<p> Potom jednoduše nastavíte u své Nabídky funkci „s sebou“. V&nbsp;takovém případě, prosím, mějte krabičky na jídla, do kterých je svým Hostům zabalíte. Doporučení MyCookAround je používat recyklovatelné krabičky. Stejně tak jsou Hosté, kteří mají své krabičky na jídlo, na čemž se předem můžete domluvit v&nbsp;soukromém chatu v aplikaci. </p>',
  //12
  '<p> We have a function where you set your “estimated time of consumption” in every Offer upload. It is up to you if you want to limit the time you spend with your Guests or you want to keep it open. But be aware of a fact that the more time you spend with your Guests, the more you can charge for it. </p>':
    '<p> Na MyCookAround najdete funkci „předpokládaný čas konzumace“ při každém vkládání Nabídky. Je pouze na Vás, zda chcete čas strávený s&nbsp;Hosty omezit nebo ho nechat otevřený. V&nbsp;každém případě mějte na paměti, že čím více času svým Hostům nabídnete, tím vyšší cenu si za to můžete účtovat. můžete domluvit v&nbsp;soukromém chatu v aplikaci.</p>',
  //13
  '<p> How you evaluate your Offers is up to you. If it is one meal Offer, we recommend to set the price per meal a little bit lower than restaurants sell the same meal for. For example, if “spaghetti carbonara” in your neighborhood is sold for 10 Euro, set your price to 8 Euro. If you are a farmer or homemade food producer, sell for the price you sell regularly.  </p>':
    '<p> Nastavení cen je čistě na Vás. Pokud prodáváte jako domácí kuchař teplá jídla, doporučujeme je mít o něco levnější, než mají okolní restaurace. Pokud například svíčková ve Vašem okolí vyjde na 250 korun, prodávejte porci za 200 korun, tak zvýšíte pravděpodobnost, že si ji Hosté půjdou koupit právě k&nbsp;Vám. Pokud jste farma nebo výrobce domácích produktů, mějte ceny stejné jako je máte obvykle. </p>',
  //14
  '<p> If there is no regulation in your country that would limit income via online platforms, it totally depends on your activity and will. You can sell one meal per week just not to eat alone when you cook or you can make it your full time business and cook and sell or organize events everyday. If you like the concept of MyCookAround, you can make it your full time business. If you have already an ongoing registered business (farm, homemade food producer), MyCookAround will increase your sales significantly. </p>':
    '<p> To naprosto záleží na Vás. Stejně tak Vaše daňové a legislativní povinnosti si musíte ohlídat sami. Můžete prodat jakožto domácí kuchař jedno jídlo týdně a mít tak jen lehký přivýdělek, stejně tak si z&nbsp;přípravy domácích jídel nebo produktů udělat pravidelnou výdělečnou činnost a prodávat jídla nebo organizovat pro své Hosty zážitky můžete každý den. Pokud jste farma nebo registrovaná výroba domácích potravin či výrobků, skrze MyCookAround si snadno a značně zvýšíte prodejnost. </p>',
  //15
  '<p>When you get an Order from a Guest, you get an email notification to the email address you wrote in registration of your profile.</p>':
    '<p>V momentě, kdy si Host objedn&aacute; Va&scaron;i Nab&iacute;dku, dostanete upozorněn&iacute; do V&aacute;mi uveden&eacute;ho mailu.</p>',
  //16
  '<p> To increase your profits, it is good to follow pricing strategy based on anticipated demand. For instance, times of high demand may lead to higher Offer rates, in order to maximise revenue. When you see that you live in a tourist area and your Friday evening Offers disappear fast, why not make more of them and for a bit higher price? (We still recommend to be cheaper than a restaurant to attract more people). </p>':
    '<p>Je dobré sledovat poptávku ve Vašem okolí. Například pokud žijete v&nbsp;turistické oblasti a víte, že Vaše páteční večeře či nabízené zážitky jsou ihned vyprodané, jednoduše zkuste vařit více porcí a úměrně poptávce zvyšte své ceny. </p>',
  //17
  '<p>The best way is to set your payment threshold to a certain amount and you will get your payments after you reach it. If you don ‘t set the threshold, you will get your due pay out every Wednesday. </p>':
    '<p> Jednoduše přes ikonu chatu. </p>',

  //App translation
  SEARCH_FOR: 'Hledat...',
  'Became a Guest': `Chci být Host`,
  'Became a Cook': `Chci být Kuchař`,
  Profile: `Profil`,
  'Payment Card': `Platební Karta`,
  Settings: `Nastavení`,
  Share: `Sdílet`,
  'Bank account': `Bankovní účet`,
  Logout: `Odhlásit se`,
  'Contact Support': `Kontaktovat podporu`,
  'Contact Us': `Kontaktujte Nás`,
  FAQ: 'FAQ',
  'Terms and Conditions': 'Pravidla a Podmínky',
  'Edit Profile': `Editovat Profil`,
  'My Account': `Můj účet`,
  'Push Notifications': `Oznámení push`,
  'Sign out': 'Odhlásit se',
  'Current Orders': `Aktuální objednávky`,
  'Past Orders': `Minulé objednávky`,
  'Newest First': `Nejnovější první`,
  Oldest: `Nejstarší`,
  'Filter by': `Filtrovat podle`,
  'Have any question or need help?': `Máte dotaz nebo potřebujete pomoc?`,
  'Feel free to write us. We will answer you as soon as possible.': `Neváhejte a napište nám. Odpovíme vám co nejdříve.`,
  Send: `Poslat`,
  'My Offer': `Moje nabídka`,
  'User Reviews': `Uživatelské Recenze`,
  'Meal Details': 'Detaily jídla',
  'Order Details': `Podrobnosti o objednávce`,
  'Cannot find offers': `Nelze najít nabídky`,
  'Searching Offers around': `Hledání nabídek v okolí`,
  Order: 'Objednat',
  Save: 'Uložit',
  'Currently you have no past orders': `Momentálně nemáte žádné předchozí objednávky`,
  'Currently you have no orders': `Momentálně nemáte žádné objednávky`,
  'Back to my orders': 'Zpět na mé objednávky',
  'Waiting for Accept': 'Čekání na přijetí',
  Refused: 'Odmítnuto',
  Ready: 'Připraveno',
  'Ready in': `Připraveno v`,
  ARRIVE_IN: 'Příjezd v',
  'per item': 'položka',
  Quantity: 'Množství',
  Available: 'K dispozici',
  'Cooks Details': 'Kuchaři Podrobnosti',
  'Guests Details': 'Podrobnosti hostů',
  'Take away': 'Vzít s sebou',
  'Eat with': 'Jíst spolu',
  Both: 'Oba',
  'Total Price': `Konečná cena`,
  'Your Payout': 'Vaše výplata',
  Cook: 'Kuchař',
  Guest: 'Host',
  Cooks: 'Kuchaři',
  Guests: 'Hosté',
  'Currently the cooks have no added offer':
    'V současné době kuchaři nemají přidanou nabídku',
  'Report cook': 'Nahlásit kuchaře',
  'Report guest': 'Nahlásit hosta',
  Cancel: 'Zrušení',
  'New Offer': 'Nová nabídka',
  General: 'Všeobecné',
  'Number of items available': 'Počet dostupných Položek',
  'Price per portion/item': 'Cena za porci / kus',
  'Date and Time': 'Datum a čas',
  CONSUMPTION_TYPE_MESSAGE:
    'Je dostupné ke konzumaci s Kuchařem, což znamená, že Host ho může sníst u Kuchaře doma.',
  NO_OFFER_LISTED: 'Nemáte žádnou vytvořenou žádnou nabídku',
  Done: 'Hotovo',
  Category: 'Kategorie',
  Select: 'Vyber',
  Name: 'jméno',
  Description: 'Popis',
  Restrictions: 'Omezení',
  'Type of Consumption': 'Způsob konzumace',
  TODAY: 'Dnes',
  YESTEDAY: 'Včera',
  RATE_YOUR_GUEST: 'Ohodnoť svého Hosta!',
  RATE_YOUR_COOK: 'Ohodnoť svého Kuchaře!',
  WRITE_A_NOTE: 'Napište poznámku',
  CHANGE_PASSWORD: 'Změnit heslo',
  RESET_PASSWORD: 'Resetovat heslo',
  RESET_YOUR_PASSWORD: 'Resetujte své heslo',
  RESET_PASSWORD_SUCCESSFUL: 'Vaše heslo bylo úspěšně změněno.',
  YOUR_EMAIL: `váš email`,
  WRITE_MESSAGE: 'Napište vaší zprávu',
  DETAILS: 'Detail',
  ADD_OFFER: 'Přidat nabídku',
  MEAL_NOT_EXISTS: 'Jídlo neexistuje',
  DELETE: 'Vymazat',
  DELETE_MESSAGE: 'Opravdu chcete toto jídlo smazat?',
  NO_REVIEWS: 'Zatím žádné recenze',
  USERNAME: 'Uživatelské jméno',
  PHONE_NUMBER: 'Telefonní číslo',
  STREET: 'Ulice',
  CITY: 'Město',
  NOTE: 'Poznámka',
  ZIP_CODE: `PSČ`,
  REGION: 'Kraj',
  CONSTANT_OFFER: 'Stálá Nabídka',
  Breakfast: 'Snídaně',
  Lunch: 'Oběd',
  Dinner: 'Večeře',
  AVAILABLE_DATES: 'Dostupná data',
  VIEW_DATES: 'zobrazit dostupná data',
  NO_DATES: 'data nejsou k dispozici',
  TIME_SCHEDULE: 'Časový harmonogram',
  NO_TIME_SCHEDULE: 'Žádný časový plán',
  'New Card': 'Nová karta',

  MY_ORDERS: 'Moje Objednávky',
  MY_OFFERS: 'Moje Nabídky',
  GO_TO_OFFERS: 'Jít na Moje Nabídky',
  GO_TO_ORDERS: 'Jít na Moje Objednávky',
  YOUR_OFFER: 'Vaše objednávka',
  WAS_DELETED: 'byla smazána Adminem',

  NOTIFICATIONS: 'Notifikace ',
  NEW_ORDER: 'Nová objednávka ',
  ORDER_ACCEPTED_NOTIFICATION: 'Přijatá objednávka',
  ORDER_REFUSED_NOTIFICATION: 'Objednávka odmítnuta',
  NEW_ORDER_NOTIFICATION_MESSAGE: 'Máte novou objednávku',
  OFFER_DELETED: 'Nabídka vymazána',
  OFFER_DELETED_NOTIFICATION_MESSAGE: 'Vaše objednávka byla vymazána Adminem',
  Reason: 'Důvod',
  SWITCH_ACCOUNT_MESSAGE:
    'Prosím, přepněte si účet pro zhlédnutí této Objednávky ',

  //Modals
  ORDER_ACCEPTED: 'Přijali jste objednávku!',
  Continue: 'Pokračovat',
  ACCEPT: 'Přijmout',
  REPORT_REASON: 'Váš důvod byl zaslán hostovi.',
  'Write a reason of reporting': `Napište důvod hlášení`,
  REFUSE_ORDER: 'Odmítněte objednávku',
  ACCEPTED_ORDER: 'Vaše objednávka byla přijata!',
  PICKUP_ADDRESS: 'Vyzvedněte objednávku na následující adrese na adrese',
  REFUSE_MESSAGE: 'Vaše objednávka byla odmítnuta!',
  ORDER_SENT: 'Vaše objednávka byla odeslána!',
  PROSSECCING_TO_COOK: 'Pokračování kuchaře',
  SET_VISIBLE: 'Chystáte se nastavit toto jídlo jako neviditelné.',
  VISIBLE_MESSAGE: `To může být užitečné, pokud víte, že budete jídlo později vařit
  a nechcete je smazat.`,
  DONT_SHOW_AGAIN: 'Nezobrazovat znovu',
  LOGIN_MODAL: 'Pro objednání musíte vytvořit účet nebo se přihlásit!',
  TAKE_A_MOMENT: 'Bude to chvíli trvat.',
  NO_CHAT_MESSAGE: 'Zatím nemáte žádné zprávy',
  OFFER_ORDER: 'Objednávka',
  ADDRESS: 'Adresa',
  ADDRESS_NOTES: 'Poznámka (patro, číslo bytu, atd.)',
  IMAGE_NOTE: '*obrázek by měl mít maximální velikost 400 kB',

  'Sending Order': 'Odeslání objednávky',
  'Logging in': 'Přihlašování',
  'accepted order': 'přijatá objednávka',
  REPORT_MESSAGE: 'Děkujeme za vaši zprávu. Prozkoumáme to co nejdříve.',
  'Adding Report': 'Přidání zprávy',
  CREATE_PROFILE: 'Vytvořit profil',
  // BUTTONS
  SEND_ORDER: 'Pošli Objednávku',
  NAVIGATE: 'Navigovat',
  SKIP: 'Přeskočit',
  SUBMIT: 'Poslat',
  'Signing you up': 'Registrace vás',
  'Creating profile': 'Vytváření profilu',

  // AUTHENTICATION
  CREATE_AN_ACCOUNT: 'Vytvořit účet',
  OR_SIGN_IN: 'Zaregistruj se',
  EMAIL_LOGIN: 'Přihlaš se přes email',
  FACEBOOK_LOGIN: 'Přihlaš se přes Facebook',
  GOOGLE_LOGIN: 'Přihlaš se přes Google účet',
  LOGIN: 'Přihlásit se',
  PASSWORD: 'Heslo',
  PASSWORD_AGAIN: 'Zopakujte heslo',
  NAME: 'Jméno ',
  SURNAME: 'Příjmení',
  CREATE_ACCOUNT: 'Vytvoř účet',
  CREATE: 'Vytvoř',
  I_AGREE_WITH: 'Souhlasím s',
  TERMS_AND_CONDITIONS: 'Pravidly a Podmínkami',
  FORGOT_PASSWORD: 'Zapomenuté heslo',
  FORGOT_YOUR_PASSWORD: 'Zapomenuté heslo?',
  TO_RESET_PASSWORD: 'Chcete-li obnovit své heslo, zadejte svůj e-mail.',
  PASSWORD_SENT: 'Heslo bylo zasláno na váš e-mail.',
  ADMIN_LOGIN: 'Přihlaste se jako správce',
  CREATE_COOK_ACCOUNT: 'Vytvořit účet Kuchaře',
  CREATE_GUEST_ACCOUNT: 'Vytvořit účet Hosta',
  COOKIES:
    'Abychom vylepšili naše webové stránky a poskytli vám personalizované služby, rádi bychom do vašeho zařízení ukládali soubory cookie. ',
  READ_MORE: 'Přečtěte si více.',

  //Welcome screen
  GUEST_DESCRIPTION: 'Chci nakoupit chutná jídla od různých kuchařů',
  COOK_DESCRIPTION: 'Chci prodat své menu a vařit s láskou k hostům',
  GUEST_BUY_DESCRIPTION: 'Chci nakoupit',
  GUEST_SELL_DESCRIPTION: 'Chci prodat',
  I_AM_GUEST: `Jsem Host`,
  I_AM_COOK: `Jsem Kuchař`,

  //Date Picker Weekdays
  Mo: 'Po',
  Tu: 'Út',
  We: 'St',
  Th: 'Čt',
  Fr: 'Pá',
  Sa: 'So',
  Su: 'Ne',
  //Date Picker Months
  January: 'Leden',
  February: 'Únor',
  March: 'Březen',
  April: 'Duben',
  May: 'Květen',
  June: 'Červen',
  July: 'Červenec',
  August: 'Srpen',
  September: 'Září',
  October: 'Říjen',
  November: 'Listopad',
  December: 'Prosinec',

  //Restrictions
  'Dairy Free': 'Bez laktózy',
  'Gluten Free': 'Bezlepkový',
  Halal: 'Halal',
  Kosher: 'Kosher',
  'Nut Free': 'Bez ořechů',
  Organic: 'Bio',
  Vegan: 'Vegan',
  Vegetarian: 'Vegetarian',
  'Low Carb': 'Low Carb',
  Fitness: 'Fitness',
  'Sugar Free': 'Bez cukru',
  Paleo: 'Paleo',
  GENERAL: 'Bez omezení',

  //ERROR HANDLER
  INPUT_FIRST_NAME: 'Prosím, vyplňte vaše křestní jméno! ',
  INPUT_LAST_NAME: 'Prosím, vyplňte vaše příjmení!',
  INPUT_USERNAME: 'Prosím, vyplňte vaše uživatelské jméno!',
  INPUT_DESCRIPTION: 'Prosím, vyplňte váš popis!',
  INPUT_PHONE_NUMBER: 'Prosím, vyplňte vaše telefoní číslo!',
  INPUT_STREET: 'Prosím, vyplňte adresu!',
  INPUT_CITY: 'Prosím, vyplňte město!',
  TIME_ERROR: 'Zadejte odpovídající čas.',
  CONSUMPTION_ERROR: 'Prosím, vyberte možnost spotřeby',
  DATE_ERROR: 'Prosím, vyberte datum a čas',
  IMAGE_UPLOAD_ERROR: 'Nahrajte prosím obrázek',
  MEAL_NAME_ERROR: 'Prosím, zadejte název jídla!',
  MEAL_DESCRIPTION_ERROR: 'Vyplňte prosím popis jídla!',
  PRICE_ERROR: 'Zadejte prosím cenu',
  RESCTRICTED_MESSAGE: 'Zadali jste omezená slova.',

  // SUCCESS HANDLER
  'Profile Updated': 'Profil byl aktualizován',
  'Something went wrong': 'Něco se pokazilo',

  //meal filter
  'Meal Filter': 'Filtr jídla',
  Filter: 'Filtr',
  LOCATION: 'Místo',
  NEAREST: 'Nejbližší',
  FROM: 'Od',
  TO: 'Do',
  SET: 'Nastavit',
  MAX_PRICE: 'Max cena',

  //update profile
  EDIT_PROFILE_HEADER_COOK: 'Vytvořit profil jako Cook',
  EDIT_PROFILE_HEADER_GUEST: 'Vytvořit profil jako host',
  //Edit meal
  'Edit Offer': 'Upravit nabídku',
  'Editing Offer': 'Úpravy nabídky',
  MAX_TIME: 'Max. Čas',
  //Edit meal error
  FILL_TITLE: 'Prosím, zadejte název jídla!',
  FILL_DESCRIPTION: 'Vyplňte prosím popis jídla!',
  FILL_PRICE: 'Zadejte prosím cenu',

  // PRODUCT CATEGORIES
  'Jams and marmelades': 'Jamy a marmelády',
  'Dried fruits and vegetables': 'Sušené ovoce a zelenina',
  'Fresh fruits and vegetables': 'Čerstvé ovoce a zelenina',
  'Pickled fruits and vegetables': 'Zavařené ovoce a zelenina',
  'Legumes(beans, lents...etc.)': 'Luštěniny',
  Mushrooms: 'Houby',
  'Fruit syrups and lemonade': 'Ovocné sirupy a limonády',

  'Cakes and sweets': 'Dorty a sladké',
  Puddings: 'Pudingy',
  Chocolate: 'Čokoláda',
  'Ice creams': 'Zmrzlina',
  'Bakery products and pastry': 'Pečivo a sladké pečivo',

  'Diary products(butter, cheese, milk, yogurt...etc.)': 'Mléčné výrobky',
  Honey: 'Med',
  Oils: 'Oleje',
  Eggs: 'Vajíčka',

  Grains: 'Obilí',
  'Seeds, cereals and nuts': 'Semínka, cerealie a oříšky',
  'Spices and Seasonings': 'Koření a ochucovadla',
  'Tea and herbal tea': 'Bylinkové čaje',
  Herbs: 'Bylinky',
  'Herbal syrups and lemonade': 'Bylinkové sirupy a limonády',

  'Smoked meats, hams and sausages': 'Uzeniny, šunky a klobásy',
  'Pesto, sauce and dressings': 'Pesto, omáčky a drezinky',

  'Beer, vino and destillate': 'Pivo, víno a destiláty',

  'Ready meals': 'Hotová jídla',

  Appetizers: 'Aperitivy',
  'Bread spread': 'Pomazánky',
  Pasta: 'Těstoviny',
  'Pizza and focaccia': 'Pizza a focaccia',
  'Fish, sea fruit and shellfish': 'Ryby a plody moře',
  'Meat, steaks and venison': 'Maso, steaky a zvěřina',
  'Steamed food': 'Dušené jídlo',
  'Grilled and charcoaled food': 'Grilované jídlo',
  'Roasted food': 'Pečené jídlo',
  Salads: 'Saláty',
  Soups: 'Polévky',

  'Home made natural products': 'Domácí přírodní produkty',
  'Home made tinctures': 'Domácí tinktury',

  Experience: 'Zážitky',

  'Pet food': 'Jídlo pro mazlíčky',

  // CARDS AND BANK DETAILS
  PAYMENT_CARD: 'Platební karta',
  NEW_CARD: 'Nová karta',
  BANK_ACCOUNT: 'Bankovní účet',
  NEW_ACCOUNT: 'Nový účet',
  ACCOUNT_DETAILS: 'Detail účtu',

  CARD_DETAILS: 'Detail karty',
  CARD_NUMBER: 'Číslo karty',
  CARDHOLDER_NAME: 'Jméno držitele',
  IBAN: 'IBAN',
  ACCOUNT_NUMBER: 'Číslo účtu',
  SWIFT_CODE: `SWIFT Kód/BIC`,
  BANK_NAME: 'Jméno banky',
  BANK_ADDRESS: 'Adresa banky',

  INVALID_CARD_NUMBER: 'Neplatná karta',
  INVALID_CARD_EXPIRATION: 'Platnost platební karty vypršela',
  INVALID_CVV: 'CCV je neplatné',

  EMPTY_PAYMENT_CARDS: `Žádná karta nepřidána.`,
  EMPTY_BANK_ACCOUNT: `Žádný účet nepřidán.`,
  DELETE_THIS_CARD: 'Opravdu chcete smazat tuto kartu?',
  PAYMENT_THRESHOLD: 'Limitní částka',
  PAYMENT_THRESHOLD_MESSAGE:
    'Obdržíte platbu až jakmile dosáhnete částku zde nastavenou.',

  INPUT_HOLDERS_NAME: `Prosím vložte jméno držitele!`,
  INPUT_ACCOUNT_NUMBER: `Prosím vložte číslo účtu!`,
  INPUT_IBAN: 'Prosím vložte IBAN!',
  INPUT_SWIFT_CODE: 'Prosím vložte SWIFT Kód/BIC',
  INPUT_BANK_NAME: 'Prosím vložte název banky!',
  INPUT_BANK_ADDRESS: 'Prosím vložte adresu banky!',
  INPUT_PAYMENT_THRESHOLD: 'Prosím vložte Limitní částku!',

  //Change password
  STAY_LOGGED: ' Zůstat přihlášen',
  CURRENT_PASSWORD: 'Aktuální heslo',
  NEW_PASSWORD: 'Nové heslo',
  PASSWORD_INVALID: 'Aktuální heslo je neplatné.',
  PASSWORD_CHARACTERS: 'Heslo by mělo mít alespoň 6 znaků.',
};

export default translationCZ;
